/**
 * NAV-BUTTONS — Sichtbarkeits-Regel nach BÜHNENMASS.
 *
 * Benedikt 25.09.2026 (ersetzt Jans Regel vom 09.08.2026 „überall außer
 * Smartphone"): Die zwei Weiter/Zurück-Knöpfe gibt es NUR im Querformat —
 * Vollbild am Desktop, Desktop 16:9, iPad quer 4:3. Hochkant (Smartphone
 * 9:16, iPad hoch 3:4) und Quadrat 1:1 zeigen sie nicht. Gilt überall, wo
 * der Player läuft: Voll-Reader, Vorschau-Dialog, Template-Editor-Vorschau,
 * Widget — deshalb EINE Funktion, gemessen an der Bühne (innerWidth/
 * innerHeight des Stores), nicht am Fenster: so stimmt es auch im
 * Geräterahmen der Previews.
 *
 * Zwei Bedingungen:
 *   1. QUERFORMAT: Breite/Höhe ≥ 1,2 — 4:3 (1,33) und 16:9 (1,78) sind drin,
 *      Quadrat (1,0) und alles Hochkante draußen. Die Luft bis 1,2 fängt
 *      Mess-Rundung und fast quadratische Fenster ab, die nicht als
 *      Querformat gemeint sind.
 *   2. KURZSEITE ≥ 500 px — ein quer gehaltenes Smartphone (iPhone Pro Max
 *      quer: 440 px hoch) bleibt ohne Knöpfe; Tablets beginnen bei 744.
 */
export const NAV_BUTTONS_MIN_SEITENVERHAELTNIS = 1.2;
export const NAV_BUTTONS_MIN_KURZSEITE = 500;

export function navButtonsSichtbar(
  innerWidth: number,
  innerHeight: number,
): boolean {
  if (!(innerWidth > 0) || !(innerHeight > 0)) return false;
  if (Math.min(innerWidth, innerHeight) < NAV_BUTTONS_MIN_KURZSEITE)
    return false;
  return innerWidth / innerHeight >= NAV_BUTTONS_MIN_SEITENVERHAELTNIS;
}
